import React from "react";
import { AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME } from "src/constant/common";
import { useTranslation } from "react-i18next";
import { PATTERN_NUMERIC_ARRAY_6DOF } from "src/constant/common";

const TargetPart = ({ errors, register }) => {
  const { t } = useTranslation("gnc-simulator-6dof");

  return (
    <AccordionItem>
      <AccordionHeader targetId="5" className="mt-0 fw-bold">
        {t("new.target.title")}
      </AccordionHeader>
      <AccordionBody accordionId="5">
        <div className="row">
          <div className="col-md-6">
            <FormInput
              register={register}
              type="number"
              label={t(`new.target.${FORM_NAME.TARGET.ASCENT_POSITION}`)}
              name={`target.${FORM_NAME.TARGET.ASCENT_POSITION}`}
              placeholder={t("new.field_placeholder", { field: t(`new.target.${FORM_NAME.TARGET.ASCENT_POSITION}`) })}
              classInput="width-by-percent-80"
              errors={errors?.target?.[FORM_NAME.TARGET.ASCENT_POSITION]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.target.${FORM_NAME.TARGET.ASCENT_POSITION}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.target.${FORM_NAME.TARGET.ASCENT_POSITION}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.target.${FORM_NAME.TARGET.ASCENT_POSITION}`) }),
              }}
              unit="x, y, z) (m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.target.${FORM_NAME.TARGET.ASCENT_VELOCITY}`)}
              name={`target.${FORM_NAME.TARGET.ASCENT_VELOCITY}`}
              placeholder={t("new.field_placeholder", { field: t(`new.target.${FORM_NAME.TARGET.ASCENT_VELOCITY}`) })}
              classInput="width-by-percent-80"
              errors={errors?.target?.[FORM_NAME.TARGET.ASCENT_VELOCITY]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.target.${FORM_NAME.TARGET.ASCENT_VELOCITY}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.target.${FORM_NAME.TARGET.ASCENT_VELOCITY}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.target.${FORM_NAME.TARGET.ASCENT_VELOCITY}`) }),
              }}
              unit="x, y, z) (m/s"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLA0}`)}
              name={`target.${FORM_NAME.TARGET.GEODETIC_LLA0}`}
              placeholder={t("new.target.geodetic_lla0_placeholder")}
              classInput="width-by-percent-80"
              errors={errors?.target?.[FORM_NAME.TARGET.GEODETIC_LLA0]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLA0}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLA0}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLA0}`) }),
              }}
              unit="x, y, z) (deg-deg-m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLAF}`)}
              name={`target.${FORM_NAME.TARGET.GEODETIC_LLAF}`}
              placeholder={t("new.target.geodetic_llaf_placeholder")}
              classInput="width-by-percent-80"
              errors={errors?.target?.[FORM_NAME.TARGET.GEODETIC_LLAF]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLAF}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLAF}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.target.${FORM_NAME.TARGET.GEODETIC_LLAF}`) }),
              }}
              unit="x, y, z) (deg-deg-m"
            />
            <FormInput
              register={register}
              type="number"
              label={t(`new.target.${FORM_NAME.TARGET.LANDING_VELOCITY}`)}
              name={`target.${FORM_NAME.TARGET.LANDING_VELOCITY}`}
              placeholder={t("new.field_placeholder", { field: t(`new.target.${FORM_NAME.TARGET.LANDING_VELOCITY}`) })}
              classInput="width-by-percent-80"
              errors={errors?.target?.[FORM_NAME.TARGET.LANDING_VELOCITY]?.message}
              requiredMessage={t("new.field_required", { field: t(`new.target.${FORM_NAME.TARGET.LANDING_VELOCITY}`) })}
              required
              maxLength={255}
              maxLengthMessage={t("new.field_maxlength", { field: t(`new.target.${FORM_NAME.TARGET.LANDING_VELOCITY}`) })}
              pattern={{
                value: PATTERN_NUMERIC_ARRAY_6DOF,
                message: t("new.wrong_format", { field: t(`new.target.${FORM_NAME.TARGET.LANDING_VELOCITY}`) }),
              }}
              unit="x, y, z) (m/s"
            />
          </div>
        </div>
      </AccordionBody>
    </AccordionItem>
  );
};

export default TargetPart;
